import { FC, ReactNode } from 'react'

import { CenteredBackgroundIcon } from '@/components/icons'

const ARTWORK_WIDTH = 2774
const ARTWORK_HEIGHT = 3391

type CenteredArtworkScreenProps = {
  children: ReactNode
}

/**
 * Full-viewport grid artwork. The SVG is a fixed 2774×3391 canvas; on ultrawide
 * (or very tall) screens it is scaled up from the center so the grid covers the
 * viewport without leaving the cream letterbox, while the white card stays aligned.
 */
export const CenteredArtworkScreen: FC<CenteredArtworkScreenProps> = ({ children }) => (
  <div className="fixed inset-0 overflow-hidden bg-[#FAF9F6]">
    <div
      className="absolute left-1/2 top-1/2"
      data-testid="centered-artwork"
      style={{
        width: ARTWORK_WIDTH,
        height: ARTWORK_HEIGHT,
        marginLeft: -(ARTWORK_WIDTH / 2),
        marginTop: -(ARTWORK_HEIGHT / 2),
        transform: `scale(max(1, 100vw / ${ARTWORK_WIDTH}px, 100vh / ${ARTWORK_HEIGHT}px))`,
      }}
    >
      <CenteredBackgroundIcon className="block size-full max-w-none" />
      {children}
    </div>
  </div>
)
